// extracted by mini-css-extract-plugin
export default {"container":"BlogSlider_container__MJWzN"};